import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'switches',
  props: {
    typeBold: {
      default: false
    },
    value: {
      default: false
    },
    disabled: {
      default: false
    },
    label: {
      default: ''
    },
    textEnabled: {
      default: ''
    },
    textDisabled: {
      default: ''
    },
    color: {
      default: 'default'
    },
    theme: {
      default: 'default'
    },
    emitOnMount: {
      default: true
    }
  },
  mounted: function mounted() {
    if (this.emitOnMount) {
      this.$emit('input', this.value);
    }
  },
  methods: {
    trigger: function trigger(e) {
      this.$emit('input', e.target.checked);
    }
  },
  computed: {
    classObject: function classObject() {
      var _ref;

      var color = this.color,
          value = this.value,
          theme = this.theme,
          typeBold = this.typeBold,
          disabled = this.disabled;
      return _ref = {
        'vue-switcher': true
      }, _defineProperty(_ref, 'vue-switcher--unchecked', !value), _defineProperty(_ref, 'vue-switcher--disabled', disabled), _defineProperty(_ref, 'vue-switcher--bold', typeBold), _defineProperty(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), _defineProperty(_ref, "vue-switcher-theme--".concat(theme), color), _defineProperty(_ref, "vue-switcher-color--".concat(color), color), _ref;
    },
    shouldShowLabel: function shouldShowLabel() {
      return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
    }
  }
};